module.exports = __webpack_public_path__ + "assets/exploding_head.ddf13b5de6daaa081ccc892979185417acfae864dd5b11c14e6f36c353aa1c26.png";